var _defs, _rect, _rect2, _g, _rect3, _rect4, _path, _path2, _rect5, _g2, _rect6, _rect7, _path3, _path4, _g3, _g4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8fafb;opacity:0;}.cls-2{fill:#c1cbd1;}.cls-13,.cls-14,.cls-15,.cls-16,.cls-3{opacity:0.5;}.cls-4{fill:#fafafa;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:#fff;}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12,.cls-15{fill:#47e6b1;}.cls-13{fill:#4d8af0;}.cls-13,.cls-14,.cls-15,.cls-16{isolation:isolate;}.cls-14{fill:#e29c10;}.cls-16{fill:#f55f44;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 74.44,
    y1: 2809.84,
    x2: 74.44,
    y2: 2814.34,
    gradientTransform: "matrix(1, 0, 0, -1, -48.19, 2822.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 74.44,
    y1: 2813.41,
    x2: 74.44,
    y2: 2818.72,
    gradientTransform: "matrix(0.98, -0.21, -0.21, -0.98, 543.41, 2775.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 16.85,
    y1: 8.52,
    x2: 35.52,
    y2: 8.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33ccae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2fc7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1aaeac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0c9dab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0392aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008faa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 43.58,
    y1: 3187.3,
    x2: 43.58,
    y2: 3191.8,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3202)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 233.5,
    y1: 3131.28,
    x2: 233.5,
    y2: 3136.6,
    gradientTransform: "matrix(1, 0, 0, -1, -189.92, 3142.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 34.49,
    y1: 10.06,
    x2: 52.67,
    y2: 10.06,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no_task_artwork") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 72
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.81,
    y: 8.04,
    width: 39.74,
    height: 54.91,
    transform: "translate(-6.74 7.44) rotate(-12.11)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.48,
    y: 8.97,
    width: 38.4,
    height: 53.05,
    transform: "translate(-6.74 7.44) rotate(-12.11)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12.93,
    y: 9.36,
    width: 37.42,
    height: 51.88,
    transform: "translate(-6.7 7.42) rotate(-12.11)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 16.97,
    y: 7.68,
    width: 18.56,
    height: 4.5,
    transform: "translate(-1.5 5.73) rotate(-12.11)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.85,3.44A2.66,2.66,0,1,0,28,5.49,2.63,2.63,0,0,0,24.85,3.44Zm.88,4.1a1.53,1.53,0,1,1,1.14-1.85v0a1.52,1.52,0,0,1-1.14,1.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.62,5.64l-7,1.5a2.51,2.51,0,0,0,.26-1.75,2.53,2.53,0,0,0-3-1.95h0a2.54,2.54,0,0,0-2,3,2.61,2.61,0,0,0,1,1.5l-7,1.5.9,4.2L35.52,9.84ZM25.08,4.49a1.46,1.46,0,0,1,1.74,1.13h0a1.47,1.47,0,1,1-1.74-1.13Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.66,
    y: 11.13,
    width: 39.74,
    height: 54.91
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.33,
    y: 12.06,
    width: 38.4,
    height: 53.05
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 24.82,
    y: 12.45,
    width: 37.42,
    height: 51.88
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 34.3,
    y: 10.2,
    width: 18.56,
    height: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M43.58,5.81a2.66,2.66,0,1,0,2.59,2.66A2.63,2.63,0,0,0,43.58,5.81Zm0,4.19a1.53,1.53,0,1,1,1.5-1.57v0A1.52,1.52,0,0,1,43.58,10Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M45.5,10a2.54,2.54,0,1,0-3.84,0H34.49v4.3H52.67V10ZM43.58,6.89a1.46,1.46,0,1,1,0,2.92h0a1.47,1.47,0,0,1,0-2.93Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1.6,
    y: 67.52,
    width: 0.34,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.8,
    y: 68.32,
    width: 1.94,
    height: 0.34
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 41.27,
    y: 0.5,
    width: 0.34,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 40.47,
    y: 1.3,
    width: 1.94,
    height: 0.34
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M70.33,70.75a.42.42,0,0,1-.24-.51.06.06,0,0,0,0,0h0a.21.21,0,0,0-.2-.23.23.23,0,0,0-.18.09h0s0,0,0,0a.42.42,0,0,1-.51.23h0a.22.22,0,0,0-.23.2.21.21,0,0,0,.09.18h0l0,0a.43.43,0,0,1,.23.51s0,0,0,0h0a.22.22,0,0,0,.2.22.23.23,0,0,0,.18-.08h0s0,0,0,0a.43.43,0,0,1,.51-.24h0a.21.21,0,0,0,.22-.2.25.25,0,0,0-.08-.18h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M12.64,52.1a.41.41,0,0,1-.24-.5.09.09,0,0,0,0-.05h0a.21.21,0,0,0-.37-.14h0l0,0a.41.41,0,0,1-.5.24h0a.2.2,0,0,0-.22.19.18.18,0,0,0,.08.18h0l0,0a.41.41,0,0,1,.24.5.11.11,0,0,0,0,.05h0a.2.2,0,0,0,.19.22.18.18,0,0,0,.18-.08h0l0,0a.4.4,0,0,1,.5-.23h0a.2.2,0,0,0,.22-.19.18.18,0,0,0-.08-.18h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M60.69,6.7a.42.42,0,0,1-.24-.51.06.06,0,0,0,0,0h0A.2.2,0,0,0,60.09,6h0l0,0a.42.42,0,0,1-.51.23h0a.21.21,0,0,0-.22.2.18.18,0,0,0,.08.18h0l0,0a.41.41,0,0,1,.23.51.09.09,0,0,1,0,.05h0a.23.23,0,0,0,.2.22A.23.23,0,0,0,60,7.37h0l0,0a.41.41,0,0,1,.5-.24h.05a.21.21,0,0,0,.22-.2.22.22,0,0,0-.08-.18h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 74.1,
    cy: 29.1,
    r: 0.68
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 21.19,
    cy: 68.39,
    r: 0.68
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 67.07,
    cy: 43.9,
    r: 0.68
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 8.13,
    cy: 9.26,
    r: 0.68
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 0.9,
    cy: 27.94,
    r: 0.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.8242b51af455bea8f502c26fb7b9258c.svg";
export { ForwardRef as ReactComponent };